'use strict';

var ScrollController = {
	controller: new ScrollMagic.Controller({
		vertical: true
	})
};
;;(function () {
	var $parallax = $('.parallax');
	var $page = $('.page');
	var $intro = $('.intro');
	var $scrollbar = $('.parallax__scrollbar');
	var $pathImgAssets = typeof staticPath !== 'undefined' ? staticPath : '';

	//Background zoom constants
	var zoomFactorMap = 1.2; //Scale of "map" bg when fully zoomed in
	var zoomFactorGraphs = 3840 / 1825; //Scale of "graphs" bg when fully zoomed in
	var zoomFactorWhole = 3840 / 2294; //Scale of whole scene when fully zoomed in


	window.HomepageParallaxSection = {

		//=========================== INTERNAL PROPERTIES ===========================

		$element: $parallax,
		$page: $page,
		$intro: $intro,
		$introFixed: $intro.find('.intro__fixed'),
		$elementFixed: $parallax.find('.parallax__fixed'),
		$elementInner: $parallax.find('.parallax__inner'),
		$content: $parallax.find('.parallax__content'),
		$screens: $parallax.find('.parallax__screen'),
		$overlay: $parallax.find('.parallax__overlay'),
		$bgWrap: $parallax.find('.parallax__bg-wrap'),
		$scrollBar: $scrollbar,
		$scrollProgress: $scrollbar.find('.parallax__scrollbar-progress'),
		$scrollMilestones: $scrollbar.find('.parallax__scrollbar-milestone'),
		$attacks: $parallax.find('.parallax__attacks'),
		$people: $parallax.find('.parallax__people'),
		$preloader: $parallax.find('.parallax__bg--preloader'),
		$mobileBg: $parallax.find('.parallax__mobile-bg'),
		backgrounds: {
			$whole: $parallax.find('.parallax__bg--whole'),
			$graphs: $parallax.find('.parallax__bg--graphs'),
			$map: $parallax.find('.parallax__bg--map')
		},
		timeline: null,
		scene: null,
		attackTimelines: [],
		scrollDirection: null,

		//=========================== FLAGS ===========================

		isLoading: false,
		isLoaded: false,
		isAttacksAnimationPaused: true,
		isPortraitMode: w.width < w.height,
		isMobile: w.device.mobile,
		isFixed: false,
		isPaddingTopSet: false,

		//=========================== CONFIGURABLE PARAMS ===========================

		overlayFadeDuration: 0.05, //How long it takes to animate overlay (seconds)
		overlayDuration: 0.1, //How long is the overlay visible (seconds)
		overlayOpacity: 0.8, //Overlay opacity when faded in (percent)
		textOpacity: 0.2, //Overlay opacity when faded out (percent)

		//=========================== PUBLIC METHODS ===========================

		initHandler: function initHandler() {
			var _this = this;

			if (this.isMobile) {
				this.$element.addClass('is-mobile');
				this.$mobileBg.css({ height: $(window).innerHeight() + 100 });
			}
			if (this.isPortraitMode) {
				this.$element.addClass('is-portrait');
			}
			if (this.isMobile) {
				this._setupMobileBackgroundVisibility();
				this._finishLoading();
				return;
			}

			this._updateScreenHeights();

			this.screenCount = this.$screens.length;

			this.sceneOffset = this.$element.offset().top + this.$elementInner.outerHeight() / 2 - window.innerHeight / 2; //Stick in the center of viewport
			this.sceneDuration = this.$content.outerHeight();

			this._setupBackgroundVisibility();

			//Setup preloading
			var preloadScene = new ScrollMagic.Scene({
				offset: this.sceneOffset - window.innerHeight,
				duration: window.innerHeight + this.sceneDuration
			}).addTo(ScrollController.controller).on('enter', function () {
				if (_this.isLoading || _this.isLoaded) {
					return;
				}

				_this.isLoading = true;
				Preload.images([{ 0: $pathImgAssets + 'i/mkt/technology/parallax/map__2.jpg' }, { 0: $pathImgAssets + 'i/mkt/technology/parallax/graphs__2.jpg' }, { 0: $pathImgAssets + 'i/mkt/technology/parallax/whole__2.jpg' }, { 0: $pathImgAssets + 'i/mkt/technology/parallax/people__2.png' }], function () {
					_this._finishLoading();
					_this._setupAnimations();
				});
			});
		},
		resizeEndHandler: function resizeEndHandler() {
			this.isPortraitMode = w.width < w.height;
			this.$element.toggleClass('is-portrait', this.isPortraitMode);

			if (this.isMobile) {
				this.$mobileBg.css({ height: $(window).innerHeight() + 100 });
			}

			if (this.isMobile || this.isPortraitMode) {
				return;
			}

			this._updateScreenHeights();
		},


		//=========================== PRIVATE METHODS ===========================

		_finishLoading: function _finishLoading() {
			this.isLoading = false;
			this.isLoaded = true;
			this.$element.addClass('is-loaded');
			EventHub.emit('parallaxReady');
		},
		_setupAnimations: function _setupAnimations() {
			var _this2 = this;

			this.timeline = new TimelineMax({
				onUpdate: function onUpdate() {
					//Scrollbar milestone coloring
					_this2.$scrollMilestones.each(function (idx, el) {
						$(el).toggleClass('parallax__scrollbar-milestone--visited', _this2.timeline._time >= _this2._getScreenCenterPointTime(idx));
					});
				}
			});

			//Scroll the texts
			/*
   TEMP
   this.timeline.to(this.$content, 1, {
   	y: -(this.$content.outerHeight() - this.$elementInner.outerHeight()),
   	ease: Power0.easeNone
   }, 0);
   */

			//Scrollbar progress
			/*
   TEMP
   this.timeline.fromTo(this.$scrollProgress, 1,
   	{scaleY: 0},
   	{scaleY: 1, ease: Power0.easeNone}, 0);
   */

			//Fade the purple overlay and scale scrollbar milestones
			/*
   TEMP
   	for (let i = 0; i < this.screenCount; i++) {
   	const fadeTimes = this._getScreenFadeTimes(i);
   	if (fadeTimes.in.from >= 0) {
   		this.timeline.add(this._getScreenFadeInTween(i), fadeTimes.in.from);
   	}
   	if (fadeTimes.out.to <= 1) {
   		this.timeline.add(this._getScreenFadeOutTween(i), fadeTimes.out.from);
   	}
   }
   */

			//Zoom the background
			/*
   TEMP
   	[
   	this._getBgZoomTween( //Ambient zooming while on "map" screen
   		this.backgrounds.$map,
   		0,
   		this._getScreenFadeTimes(1).out.from,
   		zoomFactorMap,
   		1
   	),
   	this._getBgZoomTween( //Zoom out to "graphs" screen
   		this.backgrounds.$graphs,
   		this._getScreenFadeTimes(1).out.from,
   		this._getScreenFadeTimes(2).in.to,
   		zoomFactorGraphs,
   		1
   	),
   	this._getBgZoomTween( //Ambient zooming while on "graphs" screen
   		this.backgrounds.$whole,
   		this._getScreenFadeTimes(2).in.to,
   		this._getScreenFadeTimes(2).out.from,
   		zoomFactorWhole,
   		zoomFactorWhole * 0.95
   	),
   	this._getBgZoomTween( //Ambient zooming while on "graphs" screen
   		this.backgrounds.$whole,
   		this._getScreenFadeTimes(2).out.from,
   		this._getScreenFadeTimes(3).in.to,
                    1,
                    1.1
   	),
   	this._getBgZoomTween( //Zoom out to the "whole" screen
   		this.backgrounds.$whole,
   		this._getScreenFadeTimes(2).out.from,
   		this._getScreenFadeTimes(3).in.to,
   		zoomFactorWhole * 0.95,
   		1.1
   	),
   	this._getBgZoomTween( //Ambient zooming while on "whole" screen
   		this.backgrounds.$whole,
   		this._getScreenFadeTimes(2).in.to,
                    1,
   		1,
   		1
   	)
   ].forEach((bzt) => {
   	this.timeline.add(bzt.tween, bzt.from);
   });
   */

			//Fade map background
			/*
   this.timeline.to([
   	this.backgrounds.$map,
   	this.$attacks
   ], 0.02, {opacity: 0}, this._getScreenFadeTimes(1).out.from);
   */

			//Fade graphs background
			/*
   this.timeline.to(this.backgrounds.$graphs, 0.05, {opacity: 0}, this._getScreenFadeTimes(2).out.from);
   */

			//Initial attack lines fade in between screens 0 and 1
			/*
   this.timeline.fromTo(this.$attacks, 0.1, {opacity: 0}, {opacity: 1}, this.overlayDuration / 2);
   */

			//People fade in animation between screens 2 and 3
			/*
   this.timeline.fromTo(this.$people, 0.2,
   	{opacity: 0, yPercent: 20},
   	{opacity: 1, yPercent: 0},
   	2 / 3 + this.overlayDuration / 2
   );
   */

			//Animate attack lines
			/*
   this.$attacks.find('path').each((idx, el) => {
   	this.attackTimelines.push(
   		new TimelineMax({
   			paused: this.isAttacksAnimationPaused,
   			repeat: -1,
   			repeatDelay: Math.random() * 2 + 1
   		})
   			.add(() => { //Random color with each repetition
   				TweenMax.set(el, {
   					css: {
   						stroke: Helpers.choose([
   							'#edcf7e','#edcf7e','#edcf7e', //Orange is more likely to be chosen
   							'#f7e6f1','#f7e6f1',
   							'#ec70a7'
   						])
   					}
   				});
   			})
   			.fromTo(el, 1, {drawSVG: '0% 0%'}, {drawSVG: '0% 50%', ease: Power0.easeNone})
   			.fromTo(el, 1, {drawSVG: '0% 50%'}, {drawSVG: '50% 100%', ease: Power0.easeNone})
   			.fromTo(el, 1, {drawSVG: '50% 100%'}, {drawSVG: '100% 100%', ease: Power0.easeNone})
   			.timeScale(Math.random() * 0.6 + 0.8)
   			.progress(Math.random())
   	);
   });
   */

			//Play/stop attack animations
			/*
   const controlAttackAnimations = () => {
   	this.isAttacksAnimationPaused = !this.isAttacksAnimationPaused;
   	this.attackTimelines.forEach((tl) => tl.paused(this.isAttacksAnimationPaused));
   };
   this.timeline.add(controlAttackAnimations, this._getScreenFadeTimes(0).out.from);
   this.timeline.add(controlAttackAnimations, this._getScreenFadeTimes(1).out.from);
   	//Set initial state for all animated elements
   this.timeline.set(this.$scrollMilestones.eq(0), {scale: 2}, 0);
   this.timeline.set(this.$scrollBar, {opacity: 1}, 0);
   this.timeline.set(this.$overlay, {opacity: this.overlayOpacity}, 0);
   this.timeline.set(this.$content, {opacity: 1}, 0);
   this.timeline.set([this.backgrounds.$map, this.$preloader], {scale: zoomFactorMap}, 0);
   this.timeline.set(this.backgrounds.$graphs, {scale: zoomFactorGraphs}, 0);
   this.timeline.set(this.backgrounds.$whole, {scale: zoomFactorWhole}, 0);
   this.timeline.vars.onUpdate();
   	this._setupPreSectionAnimations();
   this._setupPostSectionAnimations();
   this._setupSectionSticking();
   this._setupMilestoneClicking();
   */

			//this.timeline.set([this.backgrounds.$map, this.$preloader], {scale: 1}, 0);
		},
		_setupPreSectionAnimations: function _setupPreSectionAnimations() {
			var preSectionTl = new TimelineMax();
			preSectionTl.from(this.$screens.eq(0), 1, { yPercent: 40, opacity: 0, ease: Power0.easeNone }).from(this.$scrollBar, 0.1, { opacity: 0, ease: Power0.easeNone }, 0.9).add(this._getBgZoomTween(this.backgrounds.$map, 0, 1, zoomFactorMap * 1.05, zoomFactorMap).tween, 0);

			new ScrollMagic.Scene({
				offset: 0,
				duration: w.height
			}).addTo(ScrollController.controller).setTween(preSectionTl);
		},
		_setupPostSectionAnimations: function _setupPostSectionAnimations() {
			var postSectionTl = new TimelineMax();
			postSectionTl.to(this.$screens.eq(-1), 0.5, { yPercent: -20, opacity: 0, ease: Power0.easeNone }).to(this.$scrollBar, 0.1, { opacity: 0, ease: Power0.easeNone }, 0).add(this._getBgZoomTween(this.backgrounds.$whole, 0, 1, 1.05, 1).tween, 0);

			new ScrollMagic.Scene({
				offset: this.sceneOffset + this.sceneDuration,
				duration: w.height
			}).addTo(ScrollController.controller).setTween(postSectionTl);
		},
		_setupSectionSticking: function _setupSectionSticking() {
			var _this3 = this;

			this._recalculatePageHeight();

			this.scene = new ScrollMagic.Scene({
				offset: this.$element.offset().top,
				duration: this.sceneDuration,
				reverse: true
			}).on('enter', function () {
				_this3.isFixed = true;
			}).on('leave', function () {
				_this3.isFixed = false;
			}).on('start', function (e) {
				_this3.isPaddingTopSet = false;

				if (e.scrollDirection === 'FORWARD') {
					HomepageAnimationController.introVideo.pause();
				} else {
					// `REVERSE` scrollDirection
					HomepageAnimationController.introVideo.play();
				}
			}).setTween(this.timeline).addTo(ScrollController.controller);

			$('#introVideo')[0].play(); //Fix a bug where video stops playing on DOM change
		},
		_setupMilestoneClicking: function _setupMilestoneClicking() {
			var _this4 = this;

			this.$scrollMilestones.click(function (e) {
				var $el = $(e.currentTarget);
				var index = _this4.$scrollMilestones.index($el);
				Scroll.to(_this4.sceneOffset + _this4.sceneDuration * index / _this4.screenCount + 100);
			});
		},
		_recalculatePageHeight: function _recalculatePageHeight() {
			this.$element.css({ height: this.sceneDuration + w.height });
		},
		_setupMobileBackgroundVisibility: function _setupMobileBackgroundVisibility() {
			var _this5 = this;

			var padding = 300;
			var mobileScene = new ScrollMagic.Scene({
				offset: this.$element.offset().top - w.height - padding,
				triggerHook: 0,
				duration: this.$elementInner.outerHeight() + w.height + 2 * padding
			}).on('enter', function () {
				_this5.$mobileBg.css({ opacity: 1 });
			}).on('leave', function () {
				_this5.$mobileBg.css({ opacity: 0 });
			}).addTo(ScrollController.controller);
		},
		_setupBackgroundVisibility: function _setupBackgroundVisibility() {
			var _this6 = this;

			var padding = 300;
			var bgScene = new ScrollMagic.Scene({
				offset: -padding,
				triggerHook: 0,
				duration: this.sceneDuration + 2 * w.height + 2 * padding
			}).on('enter', function () {
				_this6.$element.css({ opacity: 1 });
			}).on('leave', function () {
				_this6.$element.css({ opacity: 0 });
			}).addTo(ScrollController.controller);
		},
		_updateScreenHeights: function _updateScreenHeights() {
			var bgWidth = 3840;
			var bgHeight = 1876;

			var parallaxWidth = Math.max(w.width, w.height / bgHeight * bgWidth);

			/**
   * TEMP
   this.$elementInner.css({
   width: parallaxWidth,
   height: parallaxWidth * bgHeight / bgWidth
   });
    */
			this.$elementInner.css({
				width: '100%',
				height: parallaxWidth * bgHeight / bgWidth
			});
			$('#textTable').css({ height: parallaxWidth * bgHeight / bgWidth });

			this.$elementFixed.css({ height: w.height });

			this.$screens.css({
				height: this.$elementInner.outerHeight()
			});
		},
		_getBgZoomTween: function _getBgZoomTween(el, fromPos, toPos, fromScale, toScale) {
			return {
				tween: TweenMax.fromTo(el, toPos - fromPos, { scale: fromScale }, {
					scale: toScale,
					immediateRender: false,
					ease: ExpoScaleEase.config(fromScale, toScale)
				}),
				from: fromPos,
				to: toPos
			};
		},
		_getScreenFadeInTween: function _getScreenFadeInTween(screenIndex) {
			return [
			//Fade overlay
			TweenMax.fromTo(this.$overlay, this.overlayFadeDuration, { opacity: 0 }, { opacity: this.overlayOpacity, immediateRender: false, ease: Power3.easeInOut }),

			//Fade text
			TweenMax.fromTo(this.$content, this.overlayFadeDuration, { opacity: this.textOpacity }, { opacity: 1, immediateRender: false, ease: Power3.easeInOut }),

			//Scale scrollbar milestone
			TweenMax.fromTo(this.$scrollMilestones.eq(screenIndex), this.overlayFadeDuration, { scale: 1 }, { scale: 2, immediateRender: false, ease: Power3.easeInOut })];
		},
		_getScreenFadeOutTween: function _getScreenFadeOutTween(screenIndex) {
			return [
			//Fade overlay
			TweenMax.fromTo(this.$overlay, this.overlayFadeDuration, { opacity: this.overlayOpacity }, { opacity: 0, immediateRender: false, ease: Power3.easeInOut }),

			//Fade text
			TweenMax.fromTo(this.$content, this.overlayFadeDuration, { opacity: 1 }, { opacity: this.textOpacity, immediateRender: false, ease: Power3.easeInOut }),

			//Scale scrollbar milestone
			TweenMax.fromTo(this.$scrollMilestones.eq(screenIndex), this.overlayFadeDuration, { scale: 2 }, { scale: 1, immediateRender: false, ease: Power3.easeInOut })];
		},
		_getScreenFadeTimes: function _getScreenFadeTimes(screenIndex) {
			var p = this._getScreenCenterPointTime(screenIndex);
			var fadeInTime = p - this.overlayDuration / 2 - this.overlayFadeDuration;
			var fadeOutTime = p + this.overlayDuration / 2;

			return {
				in: {
					from: fadeInTime,
					to: fadeInTime + this.overlayFadeDuration
				},
				out: {
					from: fadeOutTime,
					to: fadeOutTime + this.overlayFadeDuration
				}
			};
		},
		_getScreenCenterPointTime: function _getScreenCenterPointTime(screenIndex) {
			return screenIndex / (this.screenCount - 1);
		}
	};

	w.autoHandle(HomepageParallaxSection);
})();

;;var HomepageAnimationController = {
	_currentlyPlayingIndex: null,

	animations: [AnimationMalware, AnimationAi, AnimationLocation, AnimationSecurity, AnimationDevice],

	play: function play(index, duration) {
		if (w.device.mobile) {
			return;
		}

		this.animations[index].play(duration);
		this._currentlyPlayingIndex = index;
		return this;
	},
	pauseCurrent: function pauseCurrent(duration) {
		if (this._currentlyPlayingIndex !== null) {
			this.pause(this._currentlyPlayingIndex, duration);
		}

		return this;
	},
	pause: function pause(index, duration) {
		this.animations[index].pause(duration);
		this._currentlyPlayingIndex = null;
		return this;
	},


	introVideo: {
		$el: document.getElementById('introVideo'),

		play: function play() {
			this.$el.play();
		},
		pause: function pause() {
			this.$el.pause();
		}
	}
};
;;var $pathImgAssets = typeof staticPath !== 'undefined' ? staticPath : '';

var Zigzag = {

	scenes: {
		zigzag: null,
		navigation: null,
		cards: []
	},

	navigation: {
		$root: $('.navigation'),
		hoverThrottle: null,
		smallHeight: null,
		offset: 20,
		isAutoScrolling: false
	},

	zigzag: {
		$root: $('.zigzag'),
		activeTab: null,
		lastId: null,
		currentSectionIndex: null,
		animationFreeze: true
	},

	video: {
		$root: null,
		$sprite: null
	},

	selectors: {

		navigation: {
			rootContainer: '.navigation__container',
			tabs: '.navigation__tab',
			tabsContainer: '.navigation__tabs-container',
			tabsWrapper: '.navigation__tabs-wrapper',
			progress: '.navigation__line',
			tabContainer: '.navigation__tabs',
			hover: '.navigation__hover',
			icons: '.navigation__icon',
			labels: '.navigation__text',
			sectorArr: []
		},

		zigzag: {
			items: '.zigzag__item',
			svgPlaceholders: '.zigzag__svg-placeholder',
			currentSectionIndex: null
		},

		video: {
			root: '.video-thumbnail',
			sprite: '#animated-sprite-video-ai'
		}

	},

	classes: {
		navActiveClass: 'is-active',
		navigationTabsWrapperSmall: 'navigation__tabs-wrapper--small'
	},

	vars: function vars() {

		/**
   * ZigZag variables
   */
		this.zigzag.$rootHeight = this.zigzag.$root.outerHeight(true);
		this.zigzag.$items = this.zigzag.$root.find(this.selectors.zigzag.items);
		this.zigzag.$firstItem = this.zigzag.$root.find(this.selectors.zigzag.items).eq(0);
		this.zigzag.activeTab = this.zigzag.$firstItem.attr('id');
		this.zigzag.lastId = this.zigzag.activeTab;
		this.zigzag.$svgPlaceholders = this.zigzag.$root.find(this.selectors.zigzag.svgPlaceholders);

		/**
   * Navigation variables
   */
		this.navigation.$rootContainer = this.navigation.$root.find(this.selectors.navigation.rootContainer);
		this.navigation.$tabsContainer = this.navigation.$rootContainer.find(this.selectors.navigation.tabsContainer);
		this.navigation.$tabsWrapper = this.navigation.$rootContainer.find(this.selectors.navigation.tabsWrapper);
		this.navigation.$tabsWrapperSmall = this.navigation.$tabsWrapper.clone().addClass(this.classes.navigationTabsWrapperSmall).insertAfter(this.navigation.$tabsWrapper);

		this.navigation.$tabContainer = this.navigation.$rootContainer.find(this.selectors.navigation.tabContainer);
		this.navigation.$tabsStatic = this.navigation.$rootContainer.find(this.selectors.navigation.tabs);
		this.navigation.$tabs = this.navigation.$tabsWrapperSmall.find(this.selectors.navigation.tabs);
		this.navigation.$progress = this.navigation.$tabsWrapperSmall.find(this.selectors.navigation.progress);
		this.navigation.$hover = this.navigation.$tabsWrapperSmall.find(this.selectors.navigation.hover);

		/**
   * Video
   */
		this.video.$root = this.zigzag.$root.find(this.selectors.video.root);
		this.video.$sprite = this.video.$root.find(this.selectors.video.sprite);

		this.setNavHeight();
	},
	initHandler: function initHandler() {
		var _this7 = this;

		this.vars();
		this.bindEvents();

		if (HomepageParallaxSection.isLoaded) {
			this.loadAnimations();
		} else {
			EventHub.on('parallaxReady', function () {
				_this7.loadAnimations();
			});
		}

		EventHub.on('zigzagReady', function () {
			_this7.getSticky();
			_this7.progressAnim();
			_this7.setupCardAnimations();
		});
	},
	scrollStartHandler: function scrollStartHandler() {
		HomepageAnimationController.pauseCurrent(0.2);
		this.zigzag.animationFreeze = true;
	},
	scrollEndHandler: function scrollEndHandler() {

		if (this.zigzag.currentSectionIndex === null) {
			return;
		}

		HomepageAnimationController.pauseCurrent(0.2).play(this.zigzag.currentSectionIndex);
		this.zigzag.animationFreeze = false;
	},
	resizeEndHandler: function resizeEndHandler() {
		this.setNavHeight();
		this.zigzag.$rootHeight = this.zigzag.$root.outerHeight(true); //Update value
		this.scenes.zigzag.refresh();
	},
	bindEvents: function bindEvents() {
		var _this8 = this;

		var thumbnailTimeline = AnimatedSprite.createImg(this.video.$sprite, 15, 0.25);

		thumbnailTimeline.pause();

		this.video.$root.hover(function () {
			//Animate video thumbnail in AI section
			thumbnailTimeline.play();
		}, function () {
			AnimatedSprite.resetImg(_this8.video.$sprite, thumbnailTimeline);
		});

		// Throttle hover for navigation tabs.
		this.navigation.$tabs.hover(function (e) {
			_this8.navigation.targetIndex = $(e.currentTarget).index();

			if (_this8.navigation.hoverThrottle !== null) {
				return;
			}

			clearTimeout(_this8.navigation.hoverThrottle);

			_this8.navigation.hoverThrottle = setTimeout(function () {
				_this8.setActiveNavItem(_this8.navigation.targetIndex);
				_this8.navigation.hoverThrottle = null;
			}, 150);
		});
/*
		this.navigation.$tabs.add(this.navigation.$tabsStatic).on('click', function (e) {
			e.preventDefault();

			var $scrollTo = $(e.currentTarget.hash);
			var $scrollToPerex = $scrollTo.find('.zigzag__perex');

			_this8.navigation.isAutoScrolling = true;
			Scroll.navHeight = _this8.navigation.smallHeight;
			Scroll.to($scrollToPerex, 'center', function (success) {
				_this8.navigation.isAutoScrolling = false;
			});
			Scroll.navHeight = 0;
		}); */
	},
	loadAnimations: function loadAnimations() {
		var _this9 = this;

		var svgIds = [].map.call(this.zigzag.$svgPlaceholders, function (el) {
			return $(el).data('svg');
		});

		// if (this.canShowSvgAnimations()) {
		// 	var counter = svgIds.length;
		// 	svgIds.forEach(function (id, index) {
		// 		var svg = $pathImgAssets + ('i/mkt/technology/svg/unique/svg-' + id + '.svg');
		// 		SvgLoader.load(svg, function (svgMarkup) {
		// 			var $placeholder = _this9.zigzag.$svgPlaceholders.eq(index);
		// 			$placeholder[0].innerHTML = svgMarkup;
		// 			$placeholder.children().addClass('zigzag__svg');
		// 			$placeholder.children().unwrap();
		//
		// 			if (_this9.zigzag.currentSectionIndex === index && !_this9.zigzag.animationFreeze) {
		// 				HomepageAnimationController.pauseCurrent().play(index);
		// 			}
		//
		// 			if (--counter === 0) {
		// 				EventHub.emit('zigzagReady');
		// 			}
		// 		});
		// 	});
		// } else {
			Preload.images(svgIds.map(function (id) {
				return { 0: $pathImgAssets + ('i/mkt/technology/svg/raster/svg-' + id + '__2.png') };
			}), function () {
				setTimeout(function () {
					EventHub.emit('zigzagReady');
				}, 300);
			}, function (percentage, filename, index) {
				var $img = $('<img class="zigzag__svg"/>');
				$img[0].src = filename;
				_this9.zigzag.$svgPlaceholders.eq(index).append($img);
			});
		// }
	},
	setupCardAnimations: function setupCardAnimations() {

		//=========================== CARD 1 ===========================

		var $card1 = $('#card1');
		var $number1 = $card1.find('.card__heading');
		var $perex1 = $card1.find('.card__perex');
		var $curve = $('#svg-line-curve');
		var $glow = $('#svg-line-glow');
		var $glowClipPath = $('#svg-line-glow-clip-path');
		var card1Timeline = new TimelineMax();
		var card1TimelineDuration = 1.5;
		card1Timeline.add(AnimationNumber.create($number1, card1TimelineDuration, Expo.easeIn, parseInt($number1.data('number')), '%n')).from($perex1, card1TimelineDuration / 4, { opacity: 0 }, 0).from($curve, card1TimelineDuration, { drawSVG: '0% 0%', ease: Power0.easeNone }, 0).from($glowClipPath, card1TimelineDuration, { xPercent: -100, ease: Power0.easeNone }, 0);
		this.registerCardAnimation($card1, card1Timeline);

		//=========================== CARD 2 ===========================

		var $card2 = $('#card2');
		var $number2 = $card2.find('.card__heading');
		var $perex2 = $card2.find('.card__perex');
		var card2Timeline = new TimelineMax();
		var card2TimelineDuration = 1.5;

		var $bars = $('#svg-bars').children();
		var $barsBlurred = $('#svg-bars-blurred').children();
		var barsTl = new TimelineMax();

		barsTl.set([$bars, $barsBlurred], { transformOrigin: '0% 100%' }).staggerFromTo($bars, 1, { scaleY: 0 }, { scaleY: 1, ease: Power3.easeOut }, 0.8, 0).staggerFromTo($barsBlurred, 1, { scaleY: 0 }, { scaleY: 1, ease: Power3.easeOut }, 0.8, 0).duration(card2TimelineDuration);

		card2Timeline.add(AnimationNumber.create($number2, card2TimelineDuration, Expo.easeIn, parseInt($number2.data('number')), '%n')).from($perex2, card2TimelineDuration / 4, { opacity: 0 }, 0).add(barsTl, 0);
		this.registerCardAnimation($card2, card2Timeline);

		//=========================== CARD 3 ===========================

		var $card3 = $('#card3');
		var $number3 = $card3.find('.card__heading');
		var $perex3 = $card3.find('.card__perex');
		var dots = Helpers.shuffle($('#svg-map-bg-dots').children().toArray());
		var dotCounter = 0;
		var getNextDot = function getNextDot() {
			return dots[dotCounter = (dotCounter + 1) % dots.length];
		};
		var card3TimelineDuration = 1;

		TweenMax.set(dots, { transformOrigin: '50% 50%', opacity: 0 });

		var dotsTl = new TimelineMax({
			repeat: -1,
			repeatDelay: 0.3,
			onRepeat: function onRepeat() {
				var currentDot = getNextDot();
				TweenMax.fromTo(currentDot, 1.5, { scale: 0 }, { scale: 1.5, ease: Power3.easeOut });
				TweenMax.fromTo(currentDot, 1, { opacity: 1 }, { opacity: 0, delay: 0.5, ease: Power3.easeOut });
			}
		});

		var card3Timeline = new TimelineMax();
		card3Timeline.add(AnimationNumber.create($number3, card3TimelineDuration, Expo.easeIn, parseInt($number3.data('number')), '%n&nbsp;+')).from($perex3, card3TimelineDuration / 2, { opacity: 0 }, 0).add(dotsTl, 0);
		this.registerCardAnimation($card3, card3Timeline);
	},
	registerCardAnimation: function registerCardAnimation(card, timeline) {
		var cardScene = new ScrollMagic.Scene({
			triggerElement: card[0],
			triggerHook: 0.7,
			duration: 0
		});

		timeline.add(function () {
			cardScene.enabled(false);
		}, 0);

		cardScene.setTween(timeline).addTo(ScrollController.controller);

		this.scenes.cards.push(cardScene);
	},


	/**
  * Get sticky navigation on scroll down into <div class="zigzag"> section.
  */
	getSticky: function getSticky() {
		var _this10 = this;

		this.zigzag.$rootHeight = this.zigzag.$root.outerHeight(true); //Update value

		this.scenes.zigzag = new ScrollMagic.Scene({
			triggerElement: $('.navigation__trigger')[0],
			duration: function duration() {
				return _this10.zigzag.$rootHeight;
			},
			triggerHook: 0
		}).on('enter', function () {
			_this10.navigation.$rootContainer.addClass('is-pinned');
		}).on('leave', function () {
			_this10.navigation.$rootContainer.removeClass('is-pinned');
		}).addTo(ScrollController.controller);
	},


	/**
  * Setup active state for item from navigation menu.
  * @param index - index for active item.
  */
	setActiveNavItem: function setActiveNavItem(index) {
		var _this11 = this;

		var $target = this.navigation.$tabs.eq(index);
		this.navigation.$tabs.removeClass(this.classes.navActiveClass);

		TweenLite.to(this.navigation.$hover, 0.5, {
			xPercent: 100 * index, ease: Power3.easeInOut, onComplete: function onComplete() {
				$target.addClass(_this11.classes.navActiveClass);
			}
		});
	},


	/**
  * Animate scroll progress bar.
  */
	progressAnim: function progressAnim() {
		var _this12 = this;

		var sector = 'scene-';
		var triggerHook = this.navigation.smallHeight / w.height + //Navigation
		(w.height - this.navigation.smallHeight) / w.height / 2; //Plus a quarter of the remaining viewport

		this.sectorArr = {};

		this.zigzag.$items.each(function (itemIndex, item) {

			var scene = sector + itemIndex;
			var $line = _this12.navigation.$tabs.eq(itemIndex).find(_this12.selectors.navigation.progress);

			_this12.sectorArr[scene] = new ScrollMagic.Scene({
				triggerElement: item,
				duration: $(item).outerHeight(true),
				triggerHook: triggerHook
			}).on('enter', function () {
				if (!_this12.navigation.isAutoScrolling) {
					_this12.setActiveNavItem(itemIndex);
				}
				_this12.zigzag.currentSectionIndex = itemIndex;

				if (_this12.zigzag.animationFreeze) {
					return;
				}

				HomepageAnimationController.pauseCurrent().play(itemIndex);
			}).setTween(_this12.getProgressLineTimeline($line)).addTo(ScrollController.controller);
		});
	},
	getProgressLineTimeline: function getProgressLineTimeline($target) {
		return new TimelineMax().to($target, 1, { scaleX: 1, ease: Power0.easeNone }).to($target, 0.1, { xPercent: 100, scaleX: 1 });
	},
	canShowSvgAnimations: function canShowSvgAnimations() {
		return !w.device.mobile && w.browser.name !== 'ms msie';
	},
	setNavHeight: function setNavHeight() {
		this.navigation.smallHeight = w.height <= 800 ? 80 : 160;
	}
};
w.autoHandle(Zigzag);

;;var Homepage = {
	$page: $('.page'),
	$navigation: $('.navigation'),
	$zigzagItems: $('.zigzag__item'),
	$parallax: HomepageParallaxSection.$element,

	isReset: true,

	fastInit: function fastInit() {
		if (!storageAvailable('localStorage')) {
			return;
		}

		$('.zigzag__btn').click(function (e) {
			localStorage.setItem('avastTechnologyHomepageState', JSON.stringify({
				scrollOffset: w.top,
				parallaxHeight: HomepageParallaxSection.$element.outerHeight(),
				pageHeight: w.$document.height(),
				navigationHeight: $('.navigation').outerHeight(),
				zigzagHeights: $('.zigzag__item').toArray().map(function (item) {
					return $(item).outerHeight();
				})
			}));
		});

		var state = JSON.parse(localStorage.getItem('avastTechnologyHomepageState'));

		if (!state) {
			return;
		}

		this.$page.css({ minHeight: state.pageHeight });
		this.$parallax.css({ minHeight: state.parallaxHeight });
		this.$navigation.css({ minHeight: state.navigationHeight });
		this.$zigzagItems.each(function (index, el) {
			$(el).css({ minHeight: state.zigzagHeights[index] });
		});
		window.scrollTo(0, state.scrollOffset);

		this.isReset = false;
	},
	resizeStartHandler: function resizeStartHandler() {
		if (this.isReset) {
			return;
		}

		this.$page.css({ minHeight: '' });
		this.$parallax.css({ minHeight: '' });
		this.$navigation.css({ minHeight: '' });
		this.$zigzagItems.each(function (index, el) {
			$(el).css({ minHeight: '' });
		});
		this.isReset = true;
	}
};

if (!w.device.mobile) {
	Homepage.fastInit();
	w.autoHandle(Homepage, -1);
}
